import React, {useEffect, useState} from 'react';
import {MsalService, useRegisteredWebComponent} from '@ey/voltron-core';
import config from '@ey/voltron-config';
import styled from 'styled-components';
import env from './env';
import {labels} from '../util/utils';

const HelixWrapperV2 = ({id, wcName, className, initialVisual, unAuthorizedCallback, onErrorCallback}) => {
	const wcComponent = useRegisteredWebComponent(wcName);

	const [token, setToken] = useState();

	const url = env.getURL('Helix_Analyzer_Base_Url');

	useState(() => {
		const getAccessToken = async () => {
			try {
				let app = new MsalService(config.ad);
				let resourceUri = MsalService.getAudience(url, config.ad);
				let request = {
					resourceUri,
					account: app.getAccountByUserNameOrDefaultAccount(),
					scopes: [`${resourceUri}/.default`]
				};
				let result = await app.acquireTokenSilent(request);
				setToken(result.accessToken);
			} catch (error) {
				if (onErrorCallback) {
					onErrorCallback(error);
				}
			}
		};

		getAccessToken();
	}, []);

	const helixViewerReady = (event) => {
		console.log('helixViewerReady: ', event);
		const hxApi = event?.detail;
		const {reportKey, componentKey, filters, analyzer} = initialVisual;

		//Remove extra params
		let helixFilters = new Map(filters);
		if (helixFilters.has('isPhaseOne')) {
			helixFilters.delete('isPhaseOne');
		}

		let builder = hxApi
			.getHelixViewerBuilder(url, analyzer.projectId, analyzer.helixAnalyzerId)
			.withBearerToken(token)
			.withCustomLayout(reportKey, componentKey)
			.addParameters(helixFilters)
			.finishCustomLayout();

		console.log('builder: ', builder);
		hxApi.loadHelixViewer(builder);
	};

	const helixViewerError = (event) => {
		console.log('helixViewerError: ', event);
		if (unAuthorizedCallback) {
			unAuthorizedCallback(event?.detail);
		}
	};

	useEffect(() => {
		document.addEventListener('helixViewerReady', helixViewerReady);
		return () => {
			document.removeEventListener('helixViewerReady', helixViewerReady);
		};
	}, [initialVisual, token]);

	useEffect(() => {
		document.addEventListener('helixViewerError', helixViewerError);
		return () => {
			document.removeEventListener('helixViewerError', helixViewerError);
		};
	}, [initialVisual, token]);

	const CustomTag = `${wcName}`;
	return (
		<StyledWCWrapper wcName={wcName} className={`StyledWCWrapper ${className}`}>
			{wcComponent ? (
				<>
					{initialVisual?.filters?.get('isPhaseOne') === true ? (
						<CustomTag viewer-id={id} />
					) : (
						<>
							{initialVisual?.filters?.get('EYAcct') !== undefined ? (
								<CustomTag viewer-id={id} />
							) : (
								<>{labels.helixViewerLoader}</>
							)}
						</>
					)}
				</>
			) : (
				<>{labels.helixViewerLoader}</>
			)}
		</StyledWCWrapper>
	);
};

const StyledWCWrapper = styled.section`
	height: 100%;
	width: 100%;
	margin: 0 !important;
	display: block;
	hx-viewer {
		display: block;
		height: 100%;
		width: 100%;
		position: relative;
		.application-container {
			position: relative;
			height: 100%;
			width: 100%;
		}
		.pbi-report-container,
		.hx-viewer-container {
			background: transparent;
			position: static;
			height: 80vh;
			@media only screen and (min-width: 768px) and (max-width: 1280px) {
				height: 70vh;
			}
			iframe {
				padding: 0 var(--px-20) 0 var(--px-20);
				position: absolute;
				height: 100%;
				width: 100%;
				top: 0;
				left: 0;
			}
		}
	}
`;

export default HelixWrapperV2;
